import UnassignedReceiving from "../../../classes/UnassignedReceiving";
import { db } from "../../../boot/firebase";
import {
  collection,
  doc,
  updateDoc,
  deleteDoc,
  setDoc,
} from "firebase/firestore";

export const LISTEN_UNASSIGNED_RECEIVING = async (
  { dispatch },
  { next, error, unlisten, listenerPath } = {}
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: UnassignedReceiving,
    stateKey: "unassignedReceiving",
    path: UnassignedReceiving.getPath(),
    listenerPath: listenerPath || "unassignedReceiving",
    next,
    error,
    unlisten,
  });
};

export const SAVE_UNASSIGNED_RECEIVING = async ({ state }, { data }) => {
  const now = new Date();
  const uid = state.user.id;

  const record = new UnassignedReceiving(null, {
    ...data,
    created: now,
    createdBy: uid,
    modified: now,
    modifiedBy: uid,
  });

  const ref = doc(collection(db, UnassignedReceiving.getPath()));
  record.id = ref.id;

  await setDoc(ref, UnassignedReceiving.toFirestore(record));
  return record;
};

export const UPDATE_UNASSIGNED_RECEIVING = async (
  { state },
  { id, changes }
) => {
  const now = new Date();
  const uid = state.user.id;

  const path = UnassignedReceiving.getPath(id);
  return updateDoc(doc(db, path), {
    ...changes,
    modified: now,
    modifiedBy: uid,
  });
};

export const DELETE_UNASSIGNED_RECEIVING = async ({ state }, { id }) => {
  const path = UnassignedReceiving.getPath(id);
  return deleteDoc(doc(db, path));
};
